/* eslint-disable react/no-unstable-nested-components */
import React from "react";
import DataTable from "react-data-table-component";
import DebitoDetalhe from "./DebitoDetalhe";

const DebitosVencerCard = ({ debitosVencer, inscricao }) => {
  const tipoDebito = "A";
  const columns = [
    {
      name: "Data Vencimento",
      selector: "dataVencimentoDebito",
      maxWidth: "20%",
      center: true,
      sortable: true,
    },
    {
      name: "Valor Nominal",
      cell: (row) => row.valor.toLocaleString("pt-br", { minimumFractionDigits: 2 }),
      sortable: true,
      center: true,
    },
  ];

  return (
    <div className="col-lg-12">
      <div className="card shadow mb-1">
        <div className="card-header">
          <b>{debitosVencer.titulo}</b>
        </div>
        <div className="card-body">
          <center>
            <DataTable
              columns={columns}
              data={debitosVencer.debitos}
              expandOnRowClicked
              expandableRows
              expandableRowsComponent={DebitoDetalhe}
              expandableRowsComponentProps={{ inscricao, tipoDebito }}
            />
            <b>
              Total Geral dos {debitosVencer.titulo} R${" "}
              {debitosVencer.valorTotal.toLocaleString("pt-br", { minimumFractionDigits: 2 })}
            </b>
          </center>
        </div>
      </div>
    </div>
  );
};

export default DebitosVencerCard;
